"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeFontawesome = require("@fortawesome/react-native-fontawesome");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _native = _interopRequireDefault(require("styled-components/native"));
var _color = _interopRequireDefault(require("./styles/color"));
var _Text = _interopRequireDefault(require("../SharedComponents/Typography/Text"));
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeBrandsSvgIcons = require("@fortawesome/free-brands-svg-icons");
var _reactNative = require("react-native");
var _Helper = require("./Helper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/**
 * Link to get more details on this
 * https://github.com/FortAwesome/react-native-fontawesome
 */
_fontawesomeSvgCore.library.add(_proRegularSvgIcons.faAlignLeft, _proRegularSvgIcons.faBars, _proRegularSvgIcons.faHome, _proRegularSvgIcons.faCog, _proRegularSvgIcons.faMobile, _proRegularSvgIcons.faChevronLeft, _proRegularSvgIcons.faChevronRight, _proRegularSvgIcons.faChevronUp, _proRegularSvgIcons.faChevronDown, _proRegularSvgIcons.faEyeSlash, _proRegularSvgIcons.faEye, _proRegularSvgIcons.faCheck, _proRegularSvgIcons.faCheckCircle, _proRegularSvgIcons.faTimes, _proRegularSvgIcons.faExclamationTriangle, _proRegularSvgIcons.faExclamationCircle, _proRegularSvgIcons.faTimesCircle, _proRegularSvgIcons.faInfoCircle, _proRegularSvgIcons.faFileDownload, _proRegularSvgIcons.faRedo, _proRegularSvgIcons.faSpinner, _proRegularSvgIcons.faAngleDown, _proRegularSvgIcons.faAngleUp, _proRegularSvgIcons.faAngleRight, _proRegularSvgIcons.faLongArrowLeft, _proRegularSvgIcons.faPen, _proRegularSvgIcons.faListAlt, _proRegularSvgIcons.faPlusCircle, _proRegularSvgIcons.faLockAlt, _proRegularSvgIcons.faNewspaper, _proRegularSvgIcons.faFolder, _proRegularSvgIcons.faCalendarDay, _proRegularSvgIcons.faBell, _proSolidSvgIcons.faBell, _proRegularSvgIcons.faUser, _proRegularSvgIcons.faUserAlt, _proRegularSvgIcons.faUsers, _proSolidSvgIcons.faUserCrown, _proRegularSvgIcons.faStar, _proSolidSvgIcons.faStar, _proRegularSvgIcons.faSearch, _proRegularSvgIcons.faFileExport, _proRegularSvgIcons.faShareSquare, _proRegularSvgIcons.faFileAudio, _proRegularSvgIcons.faTrashAlt, _proRegularSvgIcons.faEllipsisH, _proRegularSvgIcons.faFileVideo, _proRegularSvgIcons.faFileImage, _proRegularSvgIcons.faFilePdf, _proRegularSvgIcons.faFileExcel, _proRegularSvgIcons.faFileAlt, _proRegularSvgIcons.faPhone, _proRegularSvgIcons.faBuilding, _proRegularSvgIcons.faMapMarkerCheck, _proRegularSvgIcons.faFile, _proRegularSvgIcons.faFileArchive, _proRegularSvgIcons.faEnvelope, _proSolidSvgIcons.faFolder, _proRegularSvgIcons.faFolderOpen, _proRegularSvgIcons.faCircle, _proRegularSvgIcons.faThumbsUp, _proRegularSvgIcons.faComment, _proRegularSvgIcons.faShare, _proRegularSvgIcons.faDownload, _proRegularSvgIcons.faTrash, _proRegularSvgIcons.faExternalLink, _proRegularSvgIcons.faQuestionCircle, _proRegularSvgIcons.faLock, _proRegularSvgIcons.faSignOut, _proRegularSvgIcons.faPlus, _proRegularSvgIcons.faArrowFromBottom, _proRegularSvgIcons.faPhoneOffice, _proRegularSvgIcons.faFingerprint, _proRegularSvgIcons.faPlayCircle, _proRegularSvgIcons.faPauseCircle, _freeSolidSvgIcons.faCircle, _proRegularSvgIcons.faBackspace, _proRegularSvgIcons.faPlay, _proRegularSvgIcons.faVideo, _proRegularSvgIcons.faCamera, _proRegularSvgIcons.faImages, _proRegularSvgIcons.faSquare, _proRegularSvgIcons.faClone, _proRegularSvgIcons.faStopCircle, _proRegularSvgIcons.faCommentAltLines, _proRegularSvgIcons.faPhoneAlt, _proRegularSvgIcons.faClipboardList, _proRegularSvgIcons.faEllipsisHAlt, _proRegularSvgIcons.faFilePowerpoint, _proRegularSvgIcons.faFileWord, _proRegularSvgIcons.faCompress, _proRegularSvgIcons.faExpand, _proRegularSvgIcons.faVolumeUp, _proRegularSvgIcons.faArrowFromTop, _proRegularSvgIcons.faMoon, _proRegularSvgIcons.faCalendarAlt, _proRegularSvgIcons.faAddressBook, _proRegularSvgIcons.faEllipsisV, _proRegularSvgIcons.faLink, _proRegularSvgIcons.faArrowDown, _proRegularSvgIcons.faArrowUp, _proRegularSvgIcons.faChartBar, _freeBrandsSvgIcons.faGoogle, _proRegularSvgIcons.faImage, _proRegularSvgIcons.faUserTag, _proRegularSvgIcons.faKey, _proRegularSvgIcons.faClock, _proRegularSvgIcons.faSort, _proSolidSvgIcons.faUsers, _proRegularSvgIcons.faHashtag, _proRegularSvgIcons.faAddressCard, _proRegularSvgIcons.faFlag);
var icons = {
  alignLeft: _proRegularSvgIcons.faAlignLeft,
  addressCard: _proRegularSvgIcons.faAddressCard,
  bars: _proRegularSvgIcons.faBars,
  home: _proRegularSvgIcons.faHome,
  cog: _proRegularSvgIcons.faCog,
  mobile: _proRegularSvgIcons.faMobile,
  leftArrow: _proRegularSvgIcons.faChevronLeft,
  rightArrow: _proRegularSvgIcons.faChevronRight,
  eyeClose: _proRegularSvgIcons.faEyeSlash,
  eyeOpen: _proRegularSvgIcons.faEye,
  check: _proRegularSvgIcons.faCheck,
  checkCircle: _proRegularSvgIcons.faCheckCircle,
  x: _proRegularSvgIcons.faTimes,
  warning: _proRegularSvgIcons.faExclamationTriangle,
  warningCircle: _proRegularSvgIcons.faExclamationCircle,
  close: _proRegularSvgIcons.faTimesCircle,
  info: _proRegularSvgIcons.faInfoCircle,
  download: _proRegularSvgIcons.faFileDownload,
  redo: _proRegularSvgIcons.faRedo,
  spinner: _proRegularSvgIcons.faSpinner,
  angleRight: _proRegularSvgIcons.faAngleRight,
  angleDown: _proRegularSvgIcons.faAngleDown,
  angleUp: _proRegularSvgIcons.faAngleUp,
  chevronLeft: _proRegularSvgIcons.faChevronLeft,
  chevronDown: _proRegularSvgIcons.faChevronDown,
  chevronUp: _proRegularSvgIcons.faChevronUp,
  longArrowLeft: _proRegularSvgIcons.faLongArrowLeft,
  pen: _proRegularSvgIcons.faPen,
  list: _proRegularSvgIcons.faListAlt,
  add: _proRegularSvgIcons.faPlusCircle,
  lockAlt: _proRegularSvgIcons.faLockAlt,
  lock: _proRegularSvgIcons.faLock,
  signOut: _proRegularSvgIcons.faSignOut,
  newsFeed: _proRegularSvgIcons.faNewspaper,
  folder: _proRegularSvgIcons.faFolder,
  folderOpen: _proRegularSvgIcons.faFolderOpen,
  event: _proRegularSvgIcons.faCalendarDay,
  calendar: _proRegularSvgIcons.faCalendarAlt,
  alert: _proRegularSvgIcons.faBell,
  solidBell: _proSolidSvgIcons.faBell,
  user: _proRegularSvgIcons.faUser,
  userAlt: _proRegularSvgIcons.faUserAlt,
  users: _proRegularSvgIcons.faUsers,
  solidUserCrown: _proSolidSvgIcons.faUserCrown,
  outlineStar: _proRegularSvgIcons.faStar,
  filledStar: _proSolidSvgIcons.faStar,
  search: _proRegularSvgIcons.faSearch,
  fileExport: _proRegularSvgIcons.faFileExport,
  fileAudio: _proRegularSvgIcons.faFileAudio,
  fileVideo: _proRegularSvgIcons.faFileVideo,
  fileImage: _proRegularSvgIcons.faFileImage,
  filePdf: _proRegularSvgIcons.faFilePdf,
  fileExcel: _proRegularSvgIcons.faFileExcel,
  filePowerpoint: _proRegularSvgIcons.faFilePowerpoint,
  fileWord: _proRegularSvgIcons.faFileWord,
  fileAlt: _proRegularSvgIcons.faFileAlt,
  file: _proRegularSvgIcons.faFile,
  fileArchive: _proRegularSvgIcons.faFileArchive,
  envelope: _proRegularSvgIcons.faEnvelope,
  solidFolder: _proSolidSvgIcons.faFolder,
  circle: _proRegularSvgIcons.faCircle,
  thumbsUp: _proRegularSvgIcons.faThumbsUp,
  comment: _proRegularSvgIcons.faComment,
  share: _proRegularSvgIcons.faShare,
  save: _proRegularSvgIcons.faDownload,
  trash: _proRegularSvgIcons.faTrash,
  trashAlt: _proRegularSvgIcons.faTrashAlt,
  link: _proRegularSvgIcons.faExternalLink,
  linkSquare: _proRegularSvgIcons.faExternalLinkSquare,
  questionCircle: _proRegularSvgIcons.faQuestionCircle,
  plus: _proRegularSvgIcons.faPlus,
  arrowFromBottom: _proRegularSvgIcons.faArrowFromBottom,
  arrowFromTop: _proRegularSvgIcons.faArrowFromTop,
  phone: _proRegularSvgIcons.faPhone,
  building: _proRegularSvgIcons.faBuilding,
  location: _proRegularSvgIcons.faMapMarkerCheck,
  more: _proRegularSvgIcons.faEllipsisH,
  shareSquare: _proRegularSvgIcons.faShareSquare,
  phoneOffice: _proRegularSvgIcons.faPhoneOffice,
  fingerPrint: _proRegularSvgIcons.faFingerprint,
  play: _proRegularSvgIcons.faPlayCircle,
  pause: _proRegularSvgIcons.faPauseCircle,
  solidCircle: _freeSolidSvgIcons.faCircle,
  backSpace: _proRegularSvgIcons.faBackspace,
  video: _proRegularSvgIcons.faVideo,
  camera: _proRegularSvgIcons.faCamera,
  image: _proRegularSvgIcons.faImage,
  images: _proRegularSvgIcons.faImages,
  simplePlay: _proRegularSvgIcons.faPlay,
  square: _proRegularSvgIcons.faSquare,
  clone: _proRegularSvgIcons.faClone,
  stop: _proRegularSvgIcons.faStopCircle,
  chat: _proRegularSvgIcons.faCommentAltLines,
  phoneAlt: _proRegularSvgIcons.faPhoneAlt,
  clipBoard: _proRegularSvgIcons.faClipboardList,
  threeDots: _proRegularSvgIcons.faEllipsisHAlt,
  compress: _proRegularSvgIcons.faCompress,
  expand: _proRegularSvgIcons.faExpand,
  audio: _proRegularSvgIcons.faVolumeUp,
  moon: _proRegularSvgIcons.faMoon,
  addressBook: _proRegularSvgIcons.faAddressBook,
  verticalDots: _proRegularSvgIcons.faEllipsisV,
  chainLink: _proRegularSvgIcons.faLink,
  arrowUp: _proRegularSvgIcons.faArrowUp,
  arrowDown: _proRegularSvgIcons.faArrowDown,
  chartBar: _proRegularSvgIcons.faChartBar,
  google: _freeBrandsSvgIcons.faGoogle,
  gripHorizontal: _proSolidSvgIcons.faGripHorizontal,
  userTag: _proRegularSvgIcons.faUserTag,
  key: _proRegularSvgIcons.faKey,
  clock: _proRegularSvgIcons.faClock,
  sort: _proRegularSvgIcons.faSort,
  hashtag: _proRegularSvgIcons.faHashtag,
  solidUsers: _proSolidSvgIcons.faUsers,
  flag: _proRegularSvgIcons.faFlag
};
var Container = _native["default"].View.withConfig({
  displayName: "Container",
  componentId: "sc-e035p1-0"
})(["width:", "px;height:", "px;"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
Container.displayName = 'Container';
var Badge = _native["default"].View.withConfig({
  displayName: "Badge",
  componentId: "sc-e035p1-1"
})(["position:absolute;right:-", "px;top:-3px;background-color:", ";border-radius:40px;width:", ";height:", ";justify-content:center;align-items:center;flex-wrap:nowrap;"], function (props) {
  return props.largeNumber ? '15' : '10';
}, function () {
  return _color["default"].danger;
}, function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
Badge.displayName = 'Badge';
_Text["default"].displayName = 'Text';
var getCursorStyling = function getCursorStyling(cursor) {
  return "\n  cursor: ".concat(cursor, ";\n");
};
var IconView = _native["default"].TouchableOpacity.withConfig({
  displayName: "IconView",
  componentId: "sc-e035p1-2"
})(["display:flex;", ""], function (props) {
  return (0, _Helper.isWeb)() ? getCursorStyling(props.cursor) : '';
});
var Icon = /*#__PURE__*/function (_React$Component) {
  _inherits(Icon, _React$Component);
  var _super = _createSuper(Icon);
  function Icon(props) {
    var _this;
    _classCallCheck(this, Icon);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "spinValue", new _reactNative.Animated.Value(0));
    _defineProperty(_assertThisInitialized(_this), "shakeValue", new _reactNative.Animated.Value(0));
    _defineProperty(_assertThisInitialized(_this), "incrementPulseValue", function () {
      var _this$state = _this.state,
        pulseCounter = _this$state.pulseCounter,
        max = _this$state.max;
      _this.setState({
        pulseCounter: (pulseCounter + 1) % max
      });
    });
    _defineProperty(_assertThisInitialized(_this), "spin", function () {
      _reactNative.Animated.loop(_reactNative.Animated.timing(_this.spinValue, {
        toValue: 1,
        duration: 2000,
        easing: _reactNative.Easing.linear,
        useNativeDriver: true
      })).start();
    });
    _defineProperty(_assertThisInitialized(_this), "shake", function () {
      _reactNative.Animated.loop(
      // Animation consists of a sequence of steps
      _reactNative.Animated.sequence([
      // start rotation in one direction (only half the time is needed)
      _reactNative.Animated.timing(_this.shakeValue, {
        toValue: 1.0,
        duration: 150,
        easing: _reactNative.Easing.linear,
        useNativeDriver: true
      }),
      // rotate in other direction, to minimum value (= twice the duration of above)
      _reactNative.Animated.timing(_this.shakeValue, {
        toValue: -5.0,
        duration: 300,
        easing: _reactNative.Easing.linear,
        useNativeDriver: true
      }),
      // return to begin position
      _reactNative.Animated.timing(_this.shakeValue, {
        toValue: 0.0,
        duration: 150,
        easing: _reactNative.Easing.linear,
        useNativeDriver: true
      })]), {
        iterations: 1
      }).start();
    });
    _this.state = {
      pulseCounter: 0,
      max: 8,
      intervalId: 0
    };
    return _this;
  }
  _createClass(Icon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        pulse = _this$props.pulse,
        spin = _this$props.spin,
        shake = _this$props.shake;
      if (shake) {
        this.shake();
      }
      if (spin) {
        this.spin();
      }
      if (pulse) {
        var intervalId = setInterval(this.incrementPulseValue, 125);
        this.setState({
          intervalId: intervalId
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.shake && this.props.shake) {
        this.shake();
      }
      if (!prevProps.spin && this.props.spin) {
        this.spin();
      }
      if (!prevProps.pulse && this.props.pulse) {
        var intervalId = setInterval(this.incrementPulseValue, 125);
        this.setState({
          intervalId: intervalId
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var intervalId = this.state.intervalId;
      clearInterval(intervalId);
    }
  }, {
    key: "getFontAwesomeIcon",
    value: function getFontAwesomeIcon() {
      var _this$props2 = this.props,
        iconName = _this$props2.iconName,
        size = _this$props2.size,
        spin = _this$props2.spin,
        pulse = _this$props2.pulse,
        onClick = _this$props2.onClick,
        position = _this$props2.position,
        testID = _this$props2.testID,
        shake = _this$props2.shake,
        color = _this$props2.color,
        cursor = _this$props2.cursor;
      var rotate = this.spinValue.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg']
      });
      var shakeIcon = this.shakeValue.interpolate({
        inputRange: [-1, 1],
        outputRange: ['-0.1rad', '0.1rad']
      });
      var icon = /*#__PURE__*/_react["default"].createElement(_reactNative.Animated.View, {
        style: shake ? {
          transform: [{
            rotate: shakeIcon
          }]
        } : spin || pulse ? {
          transform: [{
            rotate: pulse ? "".concat(this.state.pulseCounter * 45, "deg") : rotate
          }],
          position: position || 'absolute'
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeFontawesome.FontAwesomeIcon, {
        testID: testID,
        "data-cy": testID,
        icon: icons[iconName],
        color: color,
        size: size || 16,
        spin: spin,
        pulse: pulse,
        shake: shakeIcon
      }));
      var iconViewTestID = testID + '_view' || 'NativeIconButton';
      return onClick ? /*#__PURE__*/_react["default"].createElement(IconView, {
        cursor: cursor || 'pointer',
        "data-cy": iconViewTestID,
        testID: iconViewTestID,
        onPress: onClick
      }, icon) : icon;
    }
  }, {
    key: "getBadge",
    value: function getBadge(badge, testID) {
      var width;
      var largeNumber = false;
      if (badge < 10) {
        width = '16px';
      } else if (badge < 100) {
        width = '21px';
      } else {
        largeNumber = true;
        width = '26px';
      }
      return /*#__PURE__*/_react["default"].createElement(Badge, {
        largeNumber: largeNumber,
        width: width
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        testID: testID + '_badge_text',
        text: largeNumber ? '99+' : badge.toString(),
        textSize: "h6",
        fontColor: _color["default"].white,
        align: "center"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        badge = _this$props3.badge,
        size = _this$props3.size,
        testID = _this$props3.testID;
      var icon = this.getFontAwesomeIcon();
      if (!badge) {
        return icon;
      }
      var badgeComponent = this.getBadge(badge, testID);
      return /*#__PURE__*/_react["default"].createElement(Container, {
        size: size || 16
      }, icon, badgeComponent);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Icon;
}(_react["default"].Component);
var _default = Icon;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(icons, "icons", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(Badge, "Badge", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(getCursorStyling, "getCursorStyling", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(IconView, "IconView", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(Icon, "Icon", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/NativeIcon.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();